import { render, staticRenderFns } from "./editTable.vue?vue&type=template&id=1724cf84&"
import script from "./editTable.vue?vue&type=script&lang=js&"
export * from "./editTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1724cf84')) {
      api.createRecord('1724cf84', component.options)
    } else {
      api.reload('1724cf84', component.options)
    }
    module.hot.accept("./editTable.vue?vue&type=template&id=1724cf84&", function () {
      api.rerender('1724cf84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/comps/editTable.vue"
export default component.exports